import React from 'react';
import { useMsal } from '@azure/msal-react';

const Login: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(); // or loginPopup() for pop-up style
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="bg-white shadow-xl rounded-2xl p-10 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold mb-4 text-gray-800">Welcome to AI Coach</h1>
        <p className="text-sm text-gray-500 mb-6">
          Sign in with your Ashley account to begin your training.
        </p>
        <button
          onClick={handleLogin}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium shadow"
        >
          Sign in with Ashley Account
        </button>
      </div>
    </div>
  );
};

export default Login;
